<template>
  <div class="loading" v-if="isShow">
    <div style="" :style="position" class="loadingDiv">
        <img class="logo" src="https://resource.rcclchina.com.cn/logo/PC/logoLoadingPc.gif" alt="">
    </div>
</div>
</template>

<script>
export default {
  name: 'Loading',
  data() {
    return {
      isShow: false,
      left: 0,
      top: 0
    }
  },
  beforeMount () {
    this.setPosition()
    window.addEventListener('resize', this.setPosition)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setPosition)
  },
  methods: {
    setPosition () {
      this.top = (window.innerHeight - 210) / 2
      this.left = (window.innerWidth - 210) / 2
    }
  },
  computed: {
    position () {
      return {
        top: this.top+'px',
        left: this.left + 'px'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.loadingDiv {
  background: white;
  width: 210px;
  height: 210px;
  position: relative;
  border-radius: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  & .logo {
    position: relative;
    display: block;
    width: 150px;
  }
}
</style>
